import { FC } from "react";

import { Typography } from "@digital-services/ui";

import { OrganizationLink } from "@organization/components/OrganizationLink";
import { Relationship } from "@resource/models";

interface Props {
  relationship: Relationship;
}

export const OwnerKeyLinkPair: FC<Props> = props => {
  const { relationship } = props;

  return (
    <>
      <Typography className="self-center">
        {relationship.relationshipType}
      </Typography>
      <div className="flex justify-start gap-2">
        <OrganizationLink
          organizationId={relationship.entityId}
          organizationName={relationship.entityName}
          isTextBold
        />
      </div>
    </>
  );
};
